// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicOrderControllerGetCounterOrderOffenseData } from './PublicOrderControllerGetCounterOrderOffenseData.gen';
import type { PublicOrderControllerGetCounterOrderOffenseErrors } from './PublicOrderControllerGetCounterOrderOffenseErrors.gen';
import type { PublicOrderControllerGetCounterOrderOffenseResponses } from './PublicOrderControllerGetCounterOrderOffenseResponses.gen';
import type { PublicOrderControllerGetEshopOrderOffenseData } from './PublicOrderControllerGetEshopOrderOffenseData.gen';
import type { PublicOrderControllerGetEshopOrderOffenseErrors } from './PublicOrderControllerGetEshopOrderOffenseErrors.gen';
import type { PublicOrderControllerGetEshopOrderOffenseResponses } from './PublicOrderControllerGetEshopOrderOffenseResponses.gen';

export class PublicOrderController {
    /**
     * Get eshop order offense.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static getEshopOrderOffense<ThrowOnError extends boolean = false>(options: Options<PublicOrderControllerGetEshopOrderOffenseData, ThrowOnError>) {
        return (options.client ?? client).get<PublicOrderControllerGetEshopOrderOffenseResponses, PublicOrderControllerGetEshopOrderOffenseErrors, ThrowOnError>({ url: '/api/public/order/{id}/eshop/offense', ...options });
    }
    
    /**
     * Get counter order offense.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static getCounterOrderOffense<ThrowOnError extends boolean = false>(options: Options<PublicOrderControllerGetCounterOrderOffenseData, ThrowOnError>) {
        return (options.client ?? client).get<PublicOrderControllerGetCounterOrderOffenseResponses, PublicOrderControllerGetCounterOrderOffenseErrors, ThrowOnError>({ url: '/api/public/order/{id}/counter/offense', ...options });
    }
}
